module.exports = __webpack_public_path__ + "static/img/kuaishouhao.6e67fa89.png";